module.exports = __webpack_public_path__ + "static/media/spain_jerez_tapas_1600x1596.2198c206.jpg";